import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import ArrowBackButton from "../../../components/button/ArrowBackButton"
import useRemarkSettings from "./useRemarkSettings"
import { Select } from "antd"
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"
import { BsTrashFill } from "react-icons/bs"

const RemarkSettings = () => {
    const params = useParams()
    const navigate = useNavigate()
    const {
        getRemarksByProject,
        remarks,
        addNewRemarks,
        setProjectId,
        deleteThisRemark,
        handleSelectJustificationType,
        handleSelectScoringType,
        handleSelectLevel,
        handleSelectFrom,
        handleSelectTo,
        postRemarksByProject,
        getProjectPhase,
        handleSelectProjectPhase,
        isSaving,
        projectPhases
    } = useRemarkSettings()
    const callFunc = async(id) => {
        if (id) {
            // Load project phases first, then remarks
            await getProjectPhase(id)
            await getRemarksByProject(id)
            setProjectId(id)
        }
    }
    useEffect(() => {
        callFunc(params.project_id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.project_id])

    const justificationTypes = [
        {label : 'Bottom Remarks', value: 'bottom'},
        {label : 'Top Remarks', value: 'top'},
        {label : 'Bottom & Top Remarks', value: 'both'},
        {label : 'Maximum Remarks', value: 'maximum'},
    ] 

    const scoringTypes = [
        {label : 'Level', value: 'level'},
        {label : 'Rating', value: 'rating'}
    ] 

    const scoringTypesBoth = [
        {label : 'Level', value: 'level'}
    ] 

    const levelTypes = [
        {label : 1, value: 1},
        {label : 2, value: 2},
        {label : 3, value: 3},
        {label : 4, value: 4},
        {label : 5, value: 5}
    ] 

    const ratingTypes = [
        {label : 'A+', value: 'A+'},
        {label : 'A', value: 'A'},
        {label : 'B+', value: 'B+'},
        {label : 'B', value: 'B'},
        {label : 'C', value: 'C'},
        {label : 'D', value: 'D'},
    ]

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton title={"Set Remark"} isTwoSection={true}/>
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        Remark Configuration
                    </h5>
                    <ActionButtonGradient
                        onClick={(e) => {
                            e.preventDefault()
                            addNewRemarks()
                            setTimeout(() => {
                                window.scrollTo({
                                    top: document.documentElement.scrollHeight,
                                    behavior: 'smooth'
                                })
                            }, 100)
                        }}
                        variant="success"
                        children={<>
                            Add Remark
                        </>}
                    />
                </div>

                <form onSubmit={async (e) => {
                    let flag = await postRemarksByProject(e)
                    if (flag) {
                        navigate(-1)
                    }
                }}>
                    {
                        remarks.map((remark, index) => (
                            <div key={index} className="mb-4" style={{
                                padding: '20px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb'
                            }}>
                                <div className="flex-row" style={{alignItems: 'center', flexWrap: 'wrap', gap: '16px'}} >
                                    <div className="mt-1">
                                        <label htmlFor="justificationType" style={{ 
                                            fontWeight: '600', 
                                            color: '#374151', 
                                            fontSize: '14px',
                                            marginBottom: '8px',
                                            display: 'block'
                                        }}>
                                            Justification Type <span style={{color: 'red'}}>*</span>
                                        </label>
                                        <Select
                                            allowClear
                                            size="large"
                                            name="justificationType"
                                            options={justificationTypes}
                                            placeholder="Enter Justification Type"
                                            onChange={value => handleSelectJustificationType(value, index)}
                                            value={remark.JustificationType}
                                            style={{ width: '220px' }}
                                        />
                                    </div>
                                    <div className="mt-1">
                                        <label htmlFor="scoringType" style={{ 
                                            fontWeight: '600', 
                                            color: '#374151', 
                                            fontSize: '14px',
                                            marginBottom: '8px',
                                            display: 'block'
                                        }}>
                                            Scoring Type <span style={{color: 'red'}}>*</span>
                                        </label>
                                        <Select
                                            allowClear
                                            size="large"
                                            name="scoringType"
                                            options={remark.JustificationType==="both" || remark.JustificationType==="maximum"?scoringTypesBoth:scoringTypes}
                                            placeholder="Enter Scoring Type"
                                            onChange={value => handleSelectScoringType(value, index)}
                                            value={remark.ScoringType}
                                            style={{ width: '180px' }}
                                        />
                                    </div>
                                    {
                                        remark.ScoringType === "level" ?
                                        <div className="mt-1">
                                            <label htmlFor="levelType" style={{ 
                                                fontWeight: '600', 
                                                color: '#374151', 
                                                fontSize: '14px',
                                                marginBottom: '8px',
                                                display: 'block'
                                            }}>
                                                Level <span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                allowClear
                                                size="large"
                                                name="levelType"
                                                options={levelTypes}
                                                placeholder="Enter Level"
                                                onChange={value => handleSelectLevel(value, index)}
                                                value={remark.Level}
                                                style={{ width: '120px' }}
                                            />    
                                        </div>:
                                        <></>
                                    }
                                    {
                                        remark.ScoringType === "rating" ?
                                        <>
                                            <div className="mt-1">
                                                <label htmlFor="from" style={{ 
                                                    fontWeight: '600', 
                                                    color: '#374151', 
                                                    fontSize: '14px',
                                                    marginBottom: '8px',
                                                    display: 'block'
                                                }}>
                                                    From <span style={{color: 'red'}}>*</span>
                                                </label>
                                                <Select
                                                    allowClear
                                                    size="large"
                                                    name="from"
                                                    options={ratingTypes}
                                                    placeholder="Enter Rating"
                                                    onChange={value => handleSelectFrom(value, index)}
                                                    value={remark.From}
                                                    style={{ width: '120px' }}
                                                />    
                                            </div>
                                            <div className="mt-1">
                                                <label htmlFor="to" style={{ 
                                                    fontWeight: '600', 
                                                    color: '#374151', 
                                                    fontSize: '14px',
                                                    marginBottom: '8px',
                                                    display: 'block'
                                                }}>
                                                    To <span style={{color: 'red'}}>*</span>
                                                </label>
                                                <Select
                                                    allowClear
                                                    size="large"
                                                    name="to"
                                                    options={ratingTypes}
                                                    placeholder="Enter Rating"
                                                    onChange={value => handleSelectTo(value, index)}
                                                    value={remark.To}
                                                    style={{ width: '120px' }}
                                                />    
                                            </div>
                                        </>:
                                        <></>
                                    }
                                    {
                                        remark.JustificationType === "maximum" &&
                                        (
                                            projectPhases && projectPhases.length > 0 ? (
                                                <>
                                                    <div className="mt-1">
                                                        <label htmlFor="from" style={{ 
                                                            fontWeight: '600', 
                                                            color: '#374151', 
                                                            fontSize: '14px',
                                                            marginBottom: '8px',
                                                            display: 'block'
                                                        }}>
                                                            Project Phase <span style={{color: 'red'}}>*</span>
                                                        </label>
                                                        <Select
                                                            mode="multiple"
                                                            allowClear
                                                            size="large"
                                                            name="from"
                                                            options={projectPhases.map(phase => ({label: phase.Phase.Name, value: phase.ID}))}
                                                            placeholder="Select Project Phase(s)"
                                                            onChange={value => handleSelectProjectPhase(value, index)}
                                                            value={remark.From}
                                                            style={{ width: '320px' }}
                                                            maxTagCount="responsive"
                                                        />    
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="mt-1" style={{ color: '#ef4444', fontSize: '14px', alignSelf: 'flex-start' }}>
                                                    <label style={{ 
                                                        fontWeight: '600', 
                                                        color: '#374151', 
                                                        fontSize: '14px',
                                                        marginBottom: '8px',
                                                        display: 'block'
                                                    }}>
                                                        Error
                                                    </label>
                                                    Please set project phases first
                                                </div>
                                            )
                                        )
                                    }
                                    {(index > 0 || (index === 0 && remark.ProjectID)) && (
                                        <div style={{ 
                                            marginLeft: 'auto',
                                            alignSelf: 'flex-end',
                                            paddingBottom: '4px'
                                        }}>
                                            <ActionButtonGradient
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    deleteThisRemark(index, remark.ID)
                                                }}
                                                variant="danger"
                                                children={<BsTrashFill style={{ fontSize: '16px' }}/>}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    }
                    <div className="d-flex justify-content-end">
                        <ActionButtonGradient
                            type="submit"
                            variant="primary"
                            disabled={isSaving}
                            children={isSaving ? "Saving..." : "Save Changes"}
                        />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default RemarkSettings